import styled from 'styled-components';

export const StyledContainer = styled.div.attrs(props => {
  const { keys, values, up } = props.theme.breakpoints;
  const responsiveStyles = props.fluid
    ? 'max-width: 100%;'
    : values.reduce((prev, current) => {
        const widthStyle = `max-width: ${
          current > 0 ? `${(current / 100) * 93.75}px` : '100%'
        }`;
        const key = keys[values.indexOf(current)];
        const newStyle = `${
          current > 0 ? `${up(key)} { ${widthStyle} }` : widthStyle
        }`;
        return `${prev}${newStyle}`;
      }, '');

  return {
    horizontalPadding: `${props.theme.spacing(2)}px`,
    responsiveStyles,
  };
})`
  padding-left: ${props => props.horizontalPadding};
  padding-right: ${props => props.horizontalPadding};
  margin: 0 auto;
  ${props => props.responsiveStyles}
`;
